'use client';

import { useDecisions } from '../../hooks';
import { UsableNetLegacy } from './components';

export const UsableNetScript = () => {
    const isOneTrust = useDecisions('onetrust');

    if (isOneTrust) return null;

    return <UsableNetLegacy />;
};
